import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=180e8355&"
import script from "./HomeIndex.vue?vue&type=script&lang=ts&"
export * from "./HomeIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180e8355')) {
      api.createRecord('180e8355', component.options)
    } else {
      api.reload('180e8355', component.options)
    }
    module.hot.accept("./HomeIndex.vue?vue&type=template&id=180e8355&", function () {
      api.rerender('180e8355', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Home/HomeIndex.vue"
export default component.exports